import styled, { keyframes } from "styled-components";

const dotFlashing = keyframes`
    0%{
     background-color: #7E67D8;
    }
    50%, 100% {
     background-color: #ebe6ff;
  }`;

export const DotLoader = styled.div`
    position: relative;
    width: 10px;
    height: 10px;
    border-radius: 5px;
    background-color: #7E67D8;
    color: #7E67D8;
    animation: ${dotFlashing} 1s infinite linear alternate;
    animation-delay: .5s;
    margin: 0 auto;

    &:before, &:after {
        content: "";
        display: inline-block;
        position: absolute;
        top: 0;
        background-color: #7E67D8;
        color: #7E67D8;
        border-radius: 5px;
        width: 10px;
        height: 10px;
        animation: ${dotFlashing} 1s infinite alternate;
      };
    &:before {
        left: -15px;
        animation-delay: 0s;
    };
    &:after {
        left: 15px;
        animation-delay: 1s;
    };
`;
